"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var __1 = require("../");
var Model_1 = require("../Model");
var Subco = /** @class */ (function (_super) {
    __extends(Subco, _super);
    function Subco(id, name, locationId, active, tag, defaultStartTime, defaultDayStartTime, inventoryScanCompletedAt) {
        var _this = _super.call(this, id) || this;
        _this.fetchDailyShipmentOverview = function (queryParams) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Subco.makeRequest("/delivery/functions/subco-shipments/" + this.getId + queryParams, __1.METHOD.GET)];
            });
        }); };
        _this.fetchLocation = function () {
            return _this.fetchNestedModel("setLocation", __1.Location.fetch, "getLocationId");
        };
        _this.fetchUser = function () {
            return _this.fetchNestedModel("setUser", __1.User.fetchBySubcoId, "getId");
        };
        _this.fetchDrivers = function () { return __awaiter(_this, void 0, void 0, function () {
            var drivers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getId) {
                            throw new Error("No ID set for this Subcontractor");
                        }
                        return [4 /*yield*/, Subco.makeRequest("/delivery/functions/subcontractor/fetch-drivers/" + this.getId, __1.METHOD.GET, {})];
                    case 1:
                        drivers = _a.sent();
                        this.setDrivers = drivers.drivers.map(function (id) { return __1.Driver.fetch(id); });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.fetchEstimatedDrivers = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getId) {
                            throw new Error("No ID set for this Subcontractor");
                        }
                        return [4 /*yield*/, Subco.makeRequest("/delivery/functions/subcontractor/estimated-drivers/" + this.getId, __1.METHOD.GET)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.isWarehouseProcessDone = function () { return __awaiter(_this, void 0, void 0, function () {
            var completed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getId) {
                            throw new Error("No ID set for this Subcontractor");
                        }
                        return [4 /*yield*/, Subco.makeRequest("/delivery/functions/subcontractor/warehouse-process/" + this.getId, __1.METHOD.GET)];
                    case 1:
                        completed = (_a.sent()).completed;
                        return [2 /*return*/, completed];
                }
            });
        }); };
        _this.fetchShipments = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, this.fetchNestedModel("setShipments", __1.Shipment.fetchSubcoShipments, "getId")
                /**
                 * GETTERS
                 */
            ];
        }); }); };
        _this.setName = name;
        _this.setLocationId = locationId;
        _this.setActive = active;
        _this.setTag = tag;
        _this.setDefaultStartTime = defaultStartTime;
        _this.setDefaultDayStartTime = defaultDayStartTime;
        _this.inventoryScanCompletedAt = inventoryScanCompletedAt;
        return _this;
    }
    Object.defineProperty(Subco.prototype, "getName", {
        /**
         * GETTERS
         */
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "getLocationId", {
        get: function () {
            return this.locationId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "getLocation", {
        get: function () {
            return this.checkIfPropertyIsFetched("location", this.fetchLocation);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "getActive", {
        get: function () {
            return this.active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "getTag", {
        get: function () {
            return this.tag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "getDefaultStartTime", {
        get: function () {
            return this.defaultStartTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "getDefaultDayStartTime", {
        get: function () {
            return this.defaultDayStartTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "getUser", {
        get: function () {
            return this.checkIfPropertyIsFetched("user", this.fetchUser);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "getDrivers", {
        get: function () {
            return this.checkIfPropertyIsFetched("drivers", this.fetchDrivers);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "getShipments", {
        get: function () {
            return this.checkIfPropertyIsFetched("shipments", this.fetchShipments);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "setName", {
        /**
         * SETTERS
         */
        set: function (name) {
            this.name = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "setLocationId", {
        set: function (locationId) {
            this.locationId = locationId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "setLocation", {
        set: function (location) {
            this.location = location;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "setActive", {
        set: function (active) {
            this.active = active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "setTag", {
        set: function (tag) {
            this.tag = tag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "setDefaultStartTime", {
        set: function (defaultStartTime) {
            this.defaultStartTime = moment_1.default(defaultStartTime);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "setDefaultDayStartTime", {
        set: function (defaultDayStartTime) {
            this.defaultDayStartTime = moment_1.default(defaultDayStartTime);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "setUser", {
        set: function (user) {
            this.user = user;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "setDrivers", {
        set: function (drivers) {
            this.drivers = drivers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Subco.prototype, "setShipments", {
        set: function (shipments) {
            this.shipments = shipments;
        },
        enumerable: true,
        configurable: true
    });
    Subco.fetch = function (subcoId) { return __awaiter(_this, void 0, void 0, function () {
        var subco;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Subco.makeRequest("/delivery/private/subcontractor/" + subcoId, __1.METHOD.GET)];
                case 1:
                    subco = (_a.sent()).result;
                    return [2 /*return*/, new Subco(subco.id, subco.name, subco.locationId, subco.active, subco.tag, subco.defaultStartTime, subco.defaultDayStartTime, subco.inventoryScanCompletedAt)];
            }
        });
    }); };
    Subco.fetchAll = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Subco.makeRequest("/delivery/private/subcontractor", __1.METHOD.GET)];
                case 1:
                    result = (_a.sent()).result;
                    return [2 /*return*/, result.map(function (subco) {
                            return new Subco(subco.id, subco.name, subco.locationId, subco.active, subco.tag, subco.defaultStartTime, subco.defaultDayStartTime, subco.inventoryScanCompletedAt);
                        })];
            }
        });
    }); };
    Subco.fetchInvoiceSubco = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Subco.makeRequest("/delivery/functions/fetch-invoice-subco/", __1.METHOD.GET, {})
                    /**
                     * Get Central Sorting status
                     * @param subcoId Subcontructor ID
                     * @returns {Object} warehouseProcessCompletedAt: YYYY-MM-DD timestamp UTC
                     */
                ];
                case 1: return [2 /*return*/, _a.sent()
                    /**
                     * Get Central Sorting status
                     * @param subcoId Subcontructor ID
                     * @returns {Object} warehouseProcessCompletedAt: YYYY-MM-DD timestamp UTC
                     */
                ];
            }
        });
    }); };
    /**
     * Get Central Sorting status
     * @param subcoId Subcontructor ID
     * @returns {Object} warehouseProcessCompletedAt: YYYY-MM-DD timestamp UTC
     */
    Subco.getCentralSortingStatus = function (subcoId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Subco.makeRequest('/delivery/private/subcontractor/findOne', __1.METHOD.GET, {
                        filter: {
                            select: ['warehouseProcessCompletedAt'],
                            where: { id: subcoId },
                        },
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    return Subco;
}(Model_1.Model));
exports.Subco = Subco;
